import { useEffect } from 'react';

interface SEOPageMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

export default function SEOPageMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
}: SEOPageMetaProps) {
  useEffect(() => {
    const fullTitle = `${title} - 久播影院`;
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const selector = isProperty
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      const meta = document.querySelector<HTMLMetaElement>(selector);
      if (meta) {
        meta.setAttribute('content', content);
      }
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:type', ogType, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:title', fullTitle, true);
    setMeta('twitter:description', description, true);
  }, [title, description, keywords, canonicalUrl, ogType, ogImage]);

  return null;
}